import { DEFAULT_DATE } from 'config/constants';

export const calculateDiscountExpired = (
  dateFinish: string | null | undefined,
) => {
  if (!dateFinish) return false;
  return dateFinish < DEFAULT_DATE;
};
